
import { Inject, Injectable, InjectionToken } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ContextoUrlService {

  encode(url: string): string {
    return encodeURIComponent(url);
  }

  decode(url: string): string {
    return decodeURIComponent(url);
  }

  getParentUrlSafely(): string | null {
    try {
      const parentLocation = (window.parent as Window).location;
      return parentLocation.href;
    } catch (e) {
      console.error('No se puede acceder a la URL del padre', e);
    }

    try {
      return window.parent.location.href;
    } catch (e) {
      console.error('No se puede acceder a la URL del padre', e);
    }
    console.log("Nos vemos pbligados a devolver la ruta de la aplicación de alisse:", window.location.href);
    return window.location.href;
  }
}
